export const GET_CLIENT_SUCCEED = 'Client/GET_SUCCEEDED';
export const GET_CLIENT_ERROR = 'Client/GET_ERROR';
export const DELETE_CLIENT_SUCCEED = 'Client/DELETE_CLIENT_SUCCEEDED';
export const DELETE_CLIENT_ERROR = 'Client/DELETE_CLIENT_ERROR';
export const LOADING_STATE = 'Client/LOADING_STATE';

export const UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED = 'Client/UPDATE_CLIENT_WORKOUTS_ORDER_SUCCEED';
export const UPDATE_CLIENT_WORKOUTS_ORDER_ERROR = 'Client/UPDATE_CLIENT_WORKOUTS_ORDER_ERROR';
export const GET_CLIENT_WORKOUTS_ORDER_SUCCEED = 'Client/GET_CLIENT_WORKOUTS_ORDER_SUCCEED';
export const GET_CLIENT_WORKOUTS_ORDER_ERROR = 'Client/GET_CLIENT_WORKOUTS_ORDER_ERROR';
